import { Assistance } from "@b2bportal/air-booking-api";

enum AdditionalInfoFormFields {
  AssistanceRequired = "assistanceRequired",
  RedressNumber = "redressNumber",
  TravellerNumber = "travellerNumber",
}

export type AdditionalInfoFormContext = {
  [AdditionalInfoFormFields.AssistanceRequired]: Array<Assistance>;
  [AdditionalInfoFormFields.RedressNumber]: string;
  [AdditionalInfoFormFields.TravellerNumber]: string;
};

const additionalInfoDefaultValues: AdditionalInfoFormContext = {
  [AdditionalInfoFormFields.AssistanceRequired]: [],
  [AdditionalInfoFormFields.RedressNumber]: "",
  [AdditionalInfoFormFields.TravellerNumber]: "",
};

export const useAdditionalInfoFormFields = () => {
  const formFields = {
    [AdditionalInfoFormFields.AssistanceRequired]: {
      required: false,
    },
    [AdditionalInfoFormFields.RedressNumber]: {
      required: false,
    },
    [AdditionalInfoFormFields.TravellerNumber]: {
      required: false,
    },
  };

  return { formFields, additionalInfoDefaultValues };
};
